import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import { useLocale } from '../../../../../../providers/LocaleProvider';
import type { DCFormValues } from '../../modals/DefenseCounselModal';
import { DefenseCounselModalConfig } from '../../modals/DefenseCounselModal';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { DefenseCounsel as DefenseCounselType } from '../../../../../../api/types/rater-x-preset';

const DefenseCounsel = (props: AmendatoryLineItemProps) => {
  const { language } = useLocale();

  const handleAddDefenseCounsel = (formValues: DCFormValues) => {
    const _defenseCounsel = formatDefenseCounselForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: _defenseCounsel,
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(DefenseCounselModalConfig, {
          data: {
            onSubmit: handleAddDefenseCounsel,
            language,
            productType: props.productType,
            defaultValues: getDefaultDefenseCounselValues(
              props.value as DefenseCounselType
            ),
          },
          config: {
            title: `Edit ${props.fullName}`,
          },
        })}
      >
        Add/Edit
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default DefenseCounsel;

export const getDefaultDefenseCounselValues = (
  value: DefenseCounselType | undefined
) => {
  return {
    name: value?.props.name.value ?? '',
    partnerRate: value?.props.partnerRate.value ?? 0,
    associateRate: value?.props.associateRate.value ?? 0,
    paralegalRate: value?.props.paralegalRate.value ?? 0,
    otherRate: value?.props.otherRate.value ?? 0,
  };
};

export const formatDefenseCounselForState = (formValues: DCFormValues) => {
  return {
    name: { value: formValues.name },
    partnerRate: { value: formValues.partnerRate },
    associateRate: { value: formValues.associateRate },
    paralegalRate: { value: formValues.paralegalRate },
    otherRate: { value: formValues.otherRate },
  };
};
